import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import {
  BoxContainer,
  Underline,
  BoxTitle,
  BoxHead,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import Table from "../../Components/Agreement/Table";
import SearchFilterBox from "../../Components/SearchFilterBox";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import NotFoundModel from "../../Components/NotFoundModel";
import Loading from "../../Components/Loading";

const ExpiringAgreement = () => {
  
  const [filteredData, setFilteredData] = useState(null);
  const searchOptions = [{ label: "Name", value: 1 }];
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  

  const fetchInventoryList = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;

    const response = await axios.get(
      `${Config.apiUrl}/inventory/list?${query}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );

    return response.data;
  };

  const getInventorySuccess = (res) => {
    if (res?.isSuccess) {
      setApiData(res?.data || []);
      setFilteredData(res?.data || []);
    }
  };

  const getInventoryError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getInventoryMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchInventoryList, {
    onSuccess: getInventorySuccess,
    onError: getInventoryError,
  });

  useEffect(() => {
    handleClearFilter();
  }, []);



  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);

    getInventoryMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
    });
  };

  const handleClearFilter = () => {
    setFilterType("");
    setSearchQuery("");

    getInventoryMutate({
      searchQuery: "",
      filterType: "",
    });
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Agreement
            <Underline />
          </BoxTitle>
        </BoxHead>

        <FilterTableWrapper>
          <FilterWrapper>
            <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilter}
              />
            </div>

            <div className="flex gap-2 justify-end items-center"></div>
          </FilterWrapper>

          {!error && !isLoading && apiData && (
            <TableWrapper>
              <Table
                apiData={filteredData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
              />
              {(!filteredData || filteredData.length === 0) && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
        </FilterTableWrapper>
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};


const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;

export default ExpiringAgreement;



// import React, { useState, useEffect, useRef } from "react";
// import tw from "tailwind-styled-components";
// import { useMutation } from "react-query";
// import axios from "axios";
// import Config from "../../Config";
// import Loading from "../../Components/Loading";
// import Table from "../../Components/Tenants/TableForExpiring";
// import { toast } from "react-toastify";
// import {
//   BoxTitle,
//   BoxContainer,
//   BoxHead,
//   Underline,
//   FilterTableWrapper,
//   FilterWrapper,
// } from "../../Components/Styles/PageStyles";
// import { useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
// import moment from "moment";
// import SummaryCard from "../../Components/Tenants/SummaryCardForExpiring";
// import NotFoundModel from "../../Components/NotFoundModel";
// import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
// import AgreementRenew from "../../Components/Tenants/AgreementRenew";
// import SideModal from "../../Components/SideModal";
// import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
// import SearchFilterBox from "../../Components/SearchFilterBox";
// import DateRange from "../../Components/DateRange";
// import RenewedAgreementTable from "../../Components/Tenants/RenewedAgreementTable";
// import ViewAgreementDetails from "../../Components/Tenants/ViewAgreementDetails";
// import Notes from "../../Components/Tenants/Notes";

// const TenantsAgreement = () => {

//   const dummyTenants = [
//   {
//     tenantId: 1,
//     tenantName: "Rahul Sharma",
//     tenantMobile: "9876543210",
//     rent: 12000,
//     totalDues: 0,
//     agreementExpiry: "2026-04-20", // current month
//     moveInDate: "2025-04-20",
//     propName: "Sunshine Apartment",
//     roomNum: "A-101",
//     flatName: "Flat A",
//     status: 5,
//     kycStatus: 5,
//   },
//   {
//     tenantId: 2,
//     tenantName: "Amit Verma",
//     tenantMobile: "9123456780",
//     rent: 15000,
//     totalDues: 2000,
//     agreementExpiry: "2026-05-10", // next month
//     moveInDate: "2025-05-10",
//     propName: "Green Villa",
//     roomNum: "B-202",
//     flatName: "Flat B",
//     status: 5,
//     kycStatus: 4,
//   },
//   {
//     tenantId: 3,
//     tenantName: "Suresh Kumar",
//     tenantMobile: "9988776655",
//     rent: 10000,
//     totalDues: 500,
//     agreementExpiry: "2026-03-01", // expired
//     moveInDate: "2025-03-01",
//     propName: "Lake View",
//     roomNum: "C-303",
//     flatName: "Flat C",
//     status: 6,
//     kycStatus: 3,
//   },
// ];
//   const searchOptions = [
//     { label: "Mobile", value: 1 },
//     { label: "Name", value: 2 },
//   ];
//   const [previousStartDate, setPreviousStartDate] = useState(
//     moment().startOf("month").format("YYYY-MM-DD")
//   );
//   const [previousEndDate, setPreviousEndDate] = useState(
//     moment(new Date()).format("YYYY-MM-DD")
//   );

//   const [startDate, setStartDate] = useState(previousStartDate);
//   const [endDate, setEndDate] = useState(previousEndDate);
//   const [filterType, setFilterType] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const user = useSelector((state) => state.UserReducer.user);
//   const property = useSelector(
//     (state) => state.SelectPropertyReducer.selectProperty
//   );
//   const properties = useSelector((state) => state.PropertyReducer.property);
//   const [selectedProperty, setSelectedProperty] = useState(property);

//   const [isFocused, setIsFocused] = useState(false);
//   const [activeTab, setActiveTab] = useState("1");
//   const [selectedData, setSelectedData] = useState("");
//   const [isFirstTime, setIsFirstTime] = useState(true);
//   const [filter, setFilter] = useState("");
//   const [apiData, setApiData] = useState();
//   const [masterData, setMasterData] = useState();
//   const [isRenewAgreement, setIsRenewAgreement] = useState(false);
//   const [isViewAgreement, setIsViewAgreement] = useState(false);
//   const [isViewNotes, setIsViewNotes] = useState(false);

//   const [summaryData, setSummaryData] = useState({
//     totalMovedOut: 0,
//     curMonthMovedOut: 0,
//     defaulters: 0,
//     totalDefaultedDues: 0,
//   });

//   const isApiCallInProgress = useRef(false);
//   const lastApiCallTime = useRef(0);

//   const { t, i18n } = useTranslation();

//   const buildTab1Query = () => {
//     return `propId=${selectedProperty?.id}&searchVal=&filter=${filter}&platform=3`;
//   };

//   const buildTab2Query = () => {

//     return `&startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}`;
//   };

//   const fetchFunction = async () => {
//     if (isApiCallInProgress.current) {
//       return;
//     }

//     isApiCallInProgress.current = true;
//     lastApiCallTime.current = Date.now();

//     let url = "";

//     if (activeTab === "1") {
//       url = `${Config.apiUrl}/tenant/web/agreement-expiring?${buildTab1Query()}`;
//     } else if (activeTab === "2") {
//       url = `${Config.apiUrl}/tenant/list/renewed/agreements?${buildTab2Query()}`;
//     }

//     try {
//       const response = await axios.get(url, {
//         headers: {
//           authorization: "Bearer" + " " + user.token,
//           "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         },
//       });
//       return response.data;
//     } finally {
//       setTimeout(() => {
//         isApiCallInProgress.current = false;
//       }, 300);
//     }
//   };

//   const getSuccess = (res) => {
//     if (res.isSuccess === true) {
//       setApiData(res?.list || []);

//       if (activeTab === "1") {
//         setSummaryData(res?.stats || {
//           totalMovedOut: 0,
//           curMonthMovedOut: 0,
//           defaulters: 0,
//           totalDefaultedDues: 0,
//         });
//         setMasterData(res?.list || []);
//       }

//       setIsFocused(true);
//     } else {
//     }
//   };

//   const getError = (res) => {
//     isApiCallInProgress.current = false;
//   };

//   const {
//     isLoading: isLoading,
//     mutate: getListMutate,
//     error,
//     data,
//     isRefetching,
//     isFetching,
//   } = useMutation(fetchFunction, {
//     onSuccess: getSuccess,
//     onError: getError,
//   });

//   useEffect(() => {
//     if (isFirstTime) return;

//     const shouldCallApi = () => {
//       if (
//         isApiCallInProgress.current ||
//         Date.now() - lastApiCallTime.current < 300 ||
//         isFetching ||
//         isRefetching ||
//         isLoading
//       ) {
//         return false;
//       }
//       return true;
//     };

//     if (shouldCallApi()) {
//       const handler = setTimeout(() => {
//         getListMutate();
//       }, 100);

//       return () => {
//         clearTimeout(handler);
//       };
//     }
//   }, [
//     activeTab,
//     filter,
//     selectedProperty,
//     startDate,
//     endDate,
//     searchQuery,
//     filterType
//   ]);

//   useEffect(() => {
//     if (isFirstTime) {
//       const handler = setTimeout(() => {
//         getListMutate();
//         setIsFirstTime(false);
//       }, 100);
//       return () => {
//         clearTimeout(handler);
//       };
//     }
//   }, [property]);


//   // useEffect(() => {
//   //   if (!isFirstTime) {
//   //     setApiData([]);
//   //     setMasterData([]);
//   //     const handler = setTimeout(() => {
//   //       if (!isApiCallInProgress.current) {
//   //         getListMutate();
//   //       }
//   //     }, 150);

//   //     return () => {
//   //       clearTimeout(handler);
//   //     };
//   //   }
//   // }, [activeTab]);

//   useEffect(() => {
//   setApiData(dummyTenants);
//   setMasterData(dummyTenants);
//   setIsFocused(true);

//   setSummaryData({
//     totalMovedOut: 1,
//     curMonthMovedOut: 1,
//     defaulters: 2,
//     totalDefaultedDues: 2500,
//   });
// }, []);


//   const onSummaryBoxClick = (data) => {
//     if (activeTab !== "1") return;

//     sessionStorage.removeItem("tenant_expiring_page");
//     let filteredData;
//     const currentDate = moment().startOf("day");

//     if (data === "ECM") {
//       const startOfMonth = currentDate.clone().startOf("month");
//       const endOfMonth = currentDate.clone().endOf("month");

//       filteredData = masterData.filter((tenantData) => {
//         if (!tenantData.agreementExpiry) return false;

//         const expiryDate = moment(tenantData.agreementExpiry);
//         return expiryDate.isBetween(startOfMonth, endOfMonth, null, "[]");
//       });
//     } else if (data === "ENM") {
//       const startOfNextMonth = currentDate
//         .clone()
//         .add(1, "months")
//         .startOf("month");
//       const endOfNextMonth = currentDate
//         .clone()
//         .add(1, "months")
//         .endOf("month");

//       filteredData = masterData.filter((tenantData) => {
//         if (!tenantData.agreementExpiry) return false;

//         const expiryDate = moment(tenantData.agreementExpiry);
//         return expiryDate.isBetween(
//           startOfNextMonth,
//           endOfNextMonth,
//           null,
//           "[]"
//         );
//       });
//     } else if (data === "E") {
//       filteredData = masterData.filter((tenantData) => {
//         if (!tenantData.agreementExpiry) return false;

//         const expiryDate = moment(tenantData.agreementExpiry);
//         return expiryDate.isBefore(currentDate);
//       });
//     } else {
//       filteredData = masterData;
//     }
//     setApiData(filteredData);
//   };

//   //------- Renew Agreement -------
//   const renewAgreementFunction = async (values) => {
//     return await axios.post(`${Config.apiUrl}/client/agreement/renew`, values, {
//       headers: {
//         authorization: "Bearer" + " " + user.token,
//         "Content-Type": "application/json",
//       },
//     });
//   };

//   const onRenewAgreementSuccess = (data) => {
//     if (data?.data?.isSuccess === true) {
//       toast.success(data?.data?.msg || "Success");
//       setIsRenewAgreement(false);
//       getListMutate();
//     } else {
//       toast.error(data?.data?.msg || "An Error Occured");
//     }
//   };

//   const onRenewAgreementError = (data) => {
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoading: renewAgreementLoading, mutate: renewAgreementMutate } =
//     useMutation(renewAgreementFunction, {
//       onSuccess: onRenewAgreementSuccess,
//       onError: onRenewAgreementError,
//     });

//   const handleClose = () => {
//     setIsRenewAgreement(false);
//   };

//   const handlePropertySelect = (property) => {
//     setSelectedProperty(property);
//   };

//   const handleFilterChange = (values) => {
//     setFilterType(values.filterType);
//     setSearchQuery(values.searchQuery);
//   };

//   const handleClearFilters = () => {
//     if (activeTab === "1") {
//       setFilter("");
//     } else {
//       setFilterType("");
//       setSearchQuery("");
//       setStartDate(previousStartDate);
//       setEndDate(previousEndDate);
//     }
//   };

//   const getDateRangeDisplayText = () => {
//     if (
//       startDate &&
//       endDate &&
//       moment(startDate).isValid() &&
//       moment(endDate).isValid()
//     ) {
//       return (
//         moment(startDate).format("DD MMM yyyy") +
//         " - " +
//         moment(endDate).format("DD MMM yyyy")
//       );
//     }
//     return "Select Date Range";
//   };

//   const submitHandler = (values) => {
//     const newValues = {
//       startDate: moment(values.startDate).format("YYYY-MM-DD"),
//       endDate: moment(values.endDate).format("YYYY-MM-DD"),
//     };
//     setStartDate(newValues.startDate);
//     setEndDate(newValues.endDate);
//     setPreviousStartDate(newValues.startDate);
//     setPreviousEndDate(newValues.endDate);
//   };

//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//     setFilterType("");
//     setSearchQuery("");
//     setStartDate(previousStartDate);
//     setEndDate(previousEndDate);
//     setFilter("")
//   };

//   return (
//     <>
//       <BoxContainer>
//         <BoxHead>
//           <BoxTitle className="!mb-0 whitespace-nowrap">
//             Agreements
//             <Underline />
//           </BoxTitle>
//         </BoxHead>

//         <SideModal
//           isOpen={isRenewAgreement}
//           onClose={() => setIsRenewAgreement(false)}
//         >
//           <AgreementRenew
//             renewAgreementMutate={renewAgreementMutate}
//             isRenewAgreement={isRenewAgreement}
//             renewAgreementLoading={renewAgreementLoading}
//             setIsRenewAgreement={setIsRenewAgreement}
//             handleClose={handleClose}
//             selectedData={selectedData}
//           />
//         </SideModal>

//         <SideModal
//           isOpen={isViewNotes}
//           onClose={() => setIsViewNotes(false)}
//         >
//           <Notes
//             isViewNotes={isViewNotes}
//             setIsViewNotes={setIsViewNotes}
//             selectedData={selectedData}
//           />
//         </SideModal>


//         <SideModal isOpen={isViewAgreement} onClose={() => setIsViewAgreement(false)}>
//           <ViewAgreementDetails
//             setIsViewAgreement={setIsViewAgreement}
//             selectedData={selectedData}

//           />
//         </SideModal>
//         <FloorTabs>
//           <FloorTab
//             key="expiring"
//             onClick={() => handleTabChange('1')}
//             $active={activeTab === "1"}
//           >
//             Expiring Agreement
//           </FloorTab>
//           <FloorTab
//             key="valid"
//             onClick={() => handleTabChange('2')}
//             $active={activeTab === "2"}
//           >
//             Renewed Agreement
//           </FloorTab>
//         </FloorTabs>

//         {activeTab === "1" && (
//           <>
//             {(isLoading || isRefetching) && !isFocused && (
//               <SummarySkeletonLoading count={3} />
//             )}
//             {isFocused && apiData && (
//               <SummaryCard summaryData={summaryData} onClick={onSummaryBoxClick} />
//             )}

//             {!error && !isLoading && apiData && (
//               <FilterTableWrapper>
//                 <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   {/* Left: Total Record */}
//                   <div className="flex items-center">
//                     <Text>
//                       Total records:{" "}
//                       <span className="font-semibold">
//                         {apiData?.length || 0}
//                       </span>
//                     </Text>
//                   </div>
//                   <div className="flex gap-2 justify-end items-center">
//                     <PropertiesFilterDropdown
//                       properties={properties}
//                       selectedProperty={selectedProperty}
//                       onPropertySelect={handlePropertySelect}
//                       placeholder="Select Property"
//                       className="min-w-[200px] w-full md:w-[220px]"
//                     />
//                   </div>
//                 </FilterWrapper>
//                 <TableWrapper tab="1">
//                   <Table
//                     apiData={error ? [] : apiData?.length > 0 ? apiData : []}
//                     setSelectedData={setSelectedData}
//                     selectedData={selectedData}
//                     setIsRenewAgreement={setIsRenewAgreement}
//                     setIsViewNotes={setIsViewNotes}
//                   />
//                   {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"All good! No leases are expiring."} />}
//                 </TableWrapper>
//               </FilterTableWrapper>
//             )}
//           </>
//         )}

//         {activeTab === "2" && (
//           <>
//             <FilterTableWrapper>
//               <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 {/* Left: Total Record */}
//                 <div className="flex items-center">
//                   <Text>
//                     Total records:{" "}
//                     <span className="font-semibold">
//                       {apiData?.length || 0}
//                     </span>
//                   </Text>
//                 </div>
//                 {/* <StatusBadge>
//                   <Text>
//                     Renewed Agreements {data?.count || 0}
//                   </Text>
//                 </StatusBadge> */}
//                 {/* <SearchFilterBox
//                     options={searchOptions}
//                     handleFilterChange={handleFilterChange}
//                     handleClearFilters={handleClearFilters}
//                   // className="flex-1 min-w-0"
//                   /> */}
//                 <div className="flex gap-2 justify-end items-center">
//                   <DateRange
//                     submitHandler={submitHandler}
//                     defaultLabel={getDateRangeDisplayText()}
//                     className="flex-1 min-w-0"
//                   />
//                 </div>
//               </FilterWrapper>
//               {!error && !isLoading && apiData && (
//                 <TableWrapper tab="2">
//                   <RenewedAgreementTable
//                     apiData={error ? [] : apiData?.length > 0 ? apiData : []}
//                     setSelectedData={setSelectedData}
//                     selectedData={selectedData}
//                     setIsViewAgreement={setIsViewAgreement}
//                   />
//                   {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"No valid agreements found."} />}
//                 </TableWrapper>
//               )}
//             </FilterTableWrapper>

//           </>
//         )}

//         {(isLoading || isRefetching) && <Loading />}
//         {error && !isLoading && <NotFoundModel />}
//       </BoxContainer>
//     </>
//   );
// };


// const TableWrapper = tw.h1`
//   bg-white rounded-md 
//   ${props => props.tab === "1" ? "mt-4" : "mt-4"}
// `;
// const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
// const FloorTab = tw.button`
//   ${(p) =>
//     p.$active
//       ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
//       : " text-gray-700 "} 
//    px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
// `;
// // const StatusBadge = tw.div`bg-blue-100 px-4 py-2 items-center rounded-br-lg lg:mb-20 xl:mb-6 mb-2`;
// const StatusBadge = tw.div`bg-blue-100 px-4 py-2 items-center rounded-br-lg  xl:mb-6 mb-2`;
// //const Text = tw.p`text-xs text-blue-500 font-semibold `;
// const Text = tw.p`text-gray-500 text-sm font-normal `;

// export default TenantsAgreement;
























// import { useState, useEffect } from "react";
// import tw from "tailwind-styled-components";
// import { useMutation } from "react-query";
// import axios from "axios";
// import Config from "../../../Config";
// import Loading from "../../../Components/Loading";
// import {
//   BoxContainer,
//   BoxTitle,
//   BoxHead,
//   Underline,
//   FilterTableWrapper,
//   FilterWrapper,
// } from "../../../Components/Styles/PageStyles";
// import NotFoundModel from "../../../Components/NotFoundModel";
// import { useSelector } from "react-redux";
// import SearchFilterBox from "../../../Components/SearchFilterBox";
// import Table from "../../../Components/Properties/Lease/Table";
// import TableForExpiring from "../../../Components/Properties/Lease/TableForExpiring";
// import TableForLockin from "../../../Components/Properties/Lease/TableForLockin";

// import { toast } from "react-toastify";
// import {
//   useEditLandlordLease,
//   useLeaseDetails,
//   useUploadLandlordDocument,
// } from "../../../utilities/usePropertyLeaseHooks";
// import ViewLeaseDetails from "../../../Components/Properties/Lease/ViewLeaseDetails";
// import SideModal from "../../../Components/SideModal";
// import EditLandlordLeaseDetails from "../../../Components/Properties/Lease/EditLandlordLeaseDetails";
// import ManagePaymentDetails from "../../../Components/Landlords/ManagePaymentDetails";
// import { SummarySkeletonLoading } from "../../../Components/SkeletonLoading";
// //import AgreementRenew from "../../../Components/Landlords/AgreementRenew";
// import SummaryCardForExpiring from "../../../Components/Properties/Lease/SummaryCardForExpiring";
// import SummaryCardForLockin from "../../../Components/Properties/Lease/SummaryCardForLockin";

// import moment from "moment";
// import { useSaveLandlordPayment } from "../../../utilities/usePropertyLeaseHooks";

// const AgreementsList = () => {
//   const searchOptions = [
//     { label: "Mobile", value: 1 },
//     { label: "Name", value: 2 },
//     { label: "Prop Name", value: 3 },
//   ];
//   const property = useSelector(
//     (state) => state.SelectPropertyReducer.selectProperty
//   );
//   const user = useSelector((state) => state.UserReducer.user);
//   const [selectedData, setSelectedData] = useState("");
//   const [apiData, setApiData] = useState([]);
//   const [isFocused, setIsFocused] = useState(false);
//   const [filterType, setFilterType] = useState("");
//   const [activeTab, setActiveTab] = useState("1");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showViewLeaseModel, setShowViewLeaseModel] = useState(false);
//   const [showUploadForm, setShowUploadForm] = useState(false);
//   const [leaseData, setLeaseData] = useState("");
//   const [showEditLeaseModel, setShowEditLeaseModel] = useState(false);
//   const [showManagePaymentModel, setShowManagePaymentModel] = useState(false);
//   const [selectedExpense, setSelectedExpense] = useState(null);
//   const [summaryData, setSummaryData] = useState({
//     totalMovedOut: 0,
//     curMonthMovedOut: 0,
//     defaulters: 0,
//     totalDefaultedDues: 0,
//   });
//   const [masterData, setMasterData] = useState();
//   const [uploadDocument, setUploadDocument] = useState(false);

//   const isOwner =
//     user?.userType === Config.USER_TYPE.CLIENT ||
//     user?.role === Config.STAFF_ROLES.PARTNER;
//   const isAdmin =
//     user?.role === Config.STAFF_ROLES.ADMIN &&
//     user?.userType === Config.USER_TYPE.STAFF;

//   const fetchFunction = async (params) => {
//     const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
//     let url = `${Config.apiUrl}/landlord/list?${query}`;
//     if (activeTab === "2") {
//       url = `${Config.apiUrl}/landlord/web/agreement-expiring?${query}`;
//     } else if (activeTab === "3") {
//       url = `${Config.apiUrl}/landlord/web/lockin-tracker?${query}`;
//     }
//     const response = await axios.get(
//       //`${Config.apiUrl}/landlord/list?${query}`,
//       url,
//       {
//         headers: {
//           authorization: "Bearer " + user.token,
//           "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         },
//       }
//     );
//     return response.data;
//   };

//   const getSuccess = (res) => {
//     if (res.isSuccess) {
//       if (activeTab === "1") {
//         setApiData(res.landlords);
//         setIsFocused(true);
//       }
//       else if (activeTab === "2") {
//         setApiData(res?.list);
//         setSummaryData(res?.stats);
//         setMasterData(res?.list);
//       } else {
//         setApiData(res?.list);
//         setSummaryData(res?.stats);
//         setMasterData(res?.list);
//       }
//     }
//   };

//   const getError = (err) => {
//     toast.error(err?.response?.data?.msg || "An Error Occured");
//   };

//   const {
//     isLoading,
//     mutate: getListMutate,
//     error,
//     isRefetching,
//     data,
//     refetch,
//   } = useMutation(fetchFunction, {
//     onSuccess: getSuccess,
//     onError: getError,
//   });

//   // useEffect(() => {
//   //   getListMutate({ searchQuery, filterType });
//   // }, []);

//   useEffect(() => {
//     getListMutate({ searchQuery, filterType });
//   }, [activeTab]);

//   const handleFilterChange = (values) => {
//     setFilterType(values.filterType);
//     setSearchQuery(values.searchQuery);
//     getListMutate({
//       searchQuery: values.searchQuery,
//       filterType: values.filterType,
//     });
//   };

//   const handleClearFilters = () => {
//     setFilterType("");
//     setSearchQuery("");
//     getListMutate({ searchQuery: "", filterType: "" });
//   };

//   // Handle Document Upload
//   // const handleDocumentUpload = async (values) => {
//   //   return await axios.post(
//   //     `${Config.apiUrl}/client/landlord/docs/upload`,
//   //     values,
//   //     {
//   //       headers: {
//   //         authorization: "Bearer" + " " + user.token,
//   //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//   //       },
//   //     }
//   //   );
//   // };

//   // const onAddDocumentSuccess = (data) => {
//   //   if (data?.data?.isSuccess === true) {
//   //     toast.success(data?.data?.msg || "Success");
//   //     setShowUploadForm(false);
//   //   } else {
//   //     toast.error(data?.data?.msg || "An Error Occured");
//   //   }
//   // };

//   // const onAddDocumentError = (data) => {
//   //   toast.error(data?.response?.data?.msg || "An Error Occured");
//   // };

//   // const {
//   //   isLoading: addDocumentLoading,
//   //   mutate: addDocumentMutate,
//   //   data: documentData,
//   // } = useMutation(handleDocumentUpload, {
//   //   onSuccess: onAddDocumentSuccess,
//   //   onError: onAddDocumentError,
//   // });


//   const {
//     mutate: addDocumentMutate,
//     isLoading: addDocumentLoading,
//     data: documentData,
//   } = useUploadLandlordDocument({
//     token: user.token,
//     onSuccessCallback: (res) => {
//       if (res?.isSuccess === true) {
//         toast.success(res?.msg || "Success");
//         setShowUploadForm(false);
//         //setShowViewLeaseModel(false);
//       } else {
//         toast.error(res?.data?.msg || "An error occurred");
//       }
//     },
//     onErrorCallback: (error) => {
//       toast.error(
//         error?.response?.data?.msg || "An error occurred"
//       );
//     },
//   });

//   const handleCloseLeaseViewModal = () => {
//     setShowViewLeaseModel(false);
//   };

//   const handleManagePaymentModal = () => {
//     setShowManagePaymentModel(false);
//   };

//   const handleCloseLeaseEditModal = () => {
//     setShowEditLeaseModel(false);
//   };

//   // Get Lease Details
//   const { mutate: getLeaseDetails } =
//     useLeaseDetails(user.token);

//   const handleFetch = (propId) => {
//     getLeaseDetails(propId, {
//       onSuccess: (res) => {
//         if (res?.data) {
//           if (res?.data?.leaseDetails) {
//             setLeaseData(res?.data);
//             setShowViewLeaseModel(true);
//           }
//         }
//       },
//     });
//   };

//   //------- Edit Landlord details -------
//   // const editLandlordFunction = async (values) => {
//   //   return await axios.post(
//   //     `${Config.apiUrl}/property/lease/details/update`,
//   //     values,
//   //     {
//   //       headers: {
//   //         "Content-Type": "application/json",
//   //         authorization: `Bearer ${user.token}`,
//   //       },
//   //     }
//   //   );
//   // };

//   // const editLandlordSuccess = (data) => {
//   //   setShowEditLeaseModel(false);
//   //   getListMutate({ searchQuery, filterType });
//   //   toast.success(data?.data?.msg || "Success");
//   // };

//   // const editLandlordError = (data) => {
//   //   toast.error(data?.response?.data?.msg || "An Error Occured");
//   // };

//   // const { isLoading: editLandlordLoading, mutate: editLandlordMutate } =
//   //   useMutation(editLandlordFunction, {
//   //     onSuccess: editLandlordSuccess,
//   //     onError: editLandlordError,
//   //   });

//   const {
//     mutate: editLandlordMutate,
//     isLoading: editLandlordLoading,
//   } = useEditLandlordLease({
//     token: user.token,
//     onSuccessCallback: (data) => {
//       setShowEditLeaseModel(false);
//       getListMutate({ searchQuery, filterType });
//       toast.success(data?.msg || "Success");
//     },
//     onErrorCallback: (error) => {
//       toast.error(error?.response?.data?.msg || "An error occurred");
//     },
//   });

//   //------- Save Payment details -------
//   const {
//     mutate: savePaymentMutate,
//     isLoading: savePaymentLoading,
//   } = useSaveLandlordPayment({
//     token: user.token,
//     onSuccessCallback: (res) => {
//       toast.success("Payment details saved successfully");
//       getListMutate({ searchQuery: "", filterType: "" });
//       handleManagePaymentModal();
//     },
//     onErrorCallback: (error) => {
//       toast.error(
//         error?.response?.data?.msg ||
//         error?.message ||
//         "Failed to save payment details"
//       );
//     },
//   });


//   const onSummaryBoxClick = (data) => {
//     let filteredData;
//     const currentDate = moment().startOf("day");

//     if (data === "ECM") { //Expiring Current Month
//       const startOfMonth = currentDate.clone().startOf("month").format("YYYY-MM-DD");
//       const endOfMonth = currentDate.clone().endOf("month").format("YYYY-MM-DD");
//       filteredData = masterData.filter((leaseData) => {
//         if (!leaseData.endDate) return false;

//         const expiryDate = moment(leaseData.endDate);
//         return expiryDate.isBetween(startOfMonth, endOfMonth, null, "[]");
//       });
//     } else if (data === "ENM") { //Expiring Next Month
//       const startOfNextMonth = currentDate
//         .clone()
//         .add(1, "months")
//         .startOf("month");
//       const endOfNextMonth = currentDate
//         .clone()
//         .add(1, "months")
//         .endOf("month");

//       filteredData = masterData.filter((leaseData) => {
//         if (!leaseData.endDate) return false;

//         const expiryDate = moment(leaseData.endDate);
//         return expiryDate.isBetween(
//           startOfNextMonth,
//           endOfNextMonth,
//           null,
//           "[]"
//         );
//       });
//     } else if (data === "E") {
//       filteredData = masterData.filter((leaseData) => {
//         if (!leaseData.endDate) return false;

//         const expiryDate = moment(leaseData.endDate);
//         return expiryDate.isBefore(currentDate);
//       });
//     } else {
//       filteredData = masterData;
//     }
//     setApiData(filteredData);
//   };

//   const onSummaryBoxClickForExpiring = (data) => {
//     let filteredData;
//     const currentDate = moment().startOf("day");

//     if (data === "ECM") {//Expiring Current Month
//       const startOfMonth = currentDate.clone().startOf("month").format("YYYY-MM-DD");
//       const endOfMonth = currentDate.clone().endOf("month").format("YYYY-MM-DD");

//       filteredData = masterData.filter((leaseData) => {
//         if (!leaseData.startDate || leaseData.lockInPeriod === undefined) return false;
//         const expiryDate = moment(leaseData.startDate).add(leaseData.lockInPeriod, 'months');
//         return expiryDate.isBetween(startOfMonth, endOfMonth, null, "[]");
//       });

//     } else if (data === "ENM") {//Expiring Next Month
//       const startOfNextMonth = currentDate
//         .clone()
//         .add(1, "months")
//         .startOf("month");
//       const endOfNextMonth = currentDate
//         .clone()
//         .add(1, "months")
//         .endOf("month");

//       filteredData = masterData.filter((leaseData) => {
//         if (!leaseData.startDate || leaseData.lockInPeriod === undefined) return false;
//         const expiryDate = moment(leaseData.startDate).add(leaseData.lockInPeriod, 'months');
//         return expiryDate.isBetween(startOfNextMonth, endOfNextMonth, null, "[]");
//       });

//     } else if (data === "E") {
//       filteredData = masterData.filter((leaseData) => {
//         if (!leaseData.startDate || leaseData.lockInPeriod === undefined) return false;
//         const expiryDate = moment(leaseData.startDate).add(leaseData.lockInPeriod, 'months');
//         return expiryDate.isBefore(currentDate);
//       });

//     } else {
//       filteredData = masterData;
//     }
//     setApiData(filteredData);
//   };

//   // --------Upload Document---------
//   const uploadDocumentFunction = async (values) => {
//     const formData = new FormData();
//     formData.append("clientId", values.id);
//     formData.append("document", values.tenantDocumentImage);

//     return await axios.post(`${Config.apiUrl}/uploadDocument`, formData, {
//       headers: {
//         authorization: "Bearer " + user.token,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//   };

//   const onUploadDocumentSuccess = (data) => {
//     if (data?.data?.status === "OK") {
//       toast.success(data?.data?.msg || "Document uploaded successfully!");
//       apiData((prevData) =>
//         prevData.map((owner) =>
//           owner.id === selectedData.id
//             ? { ...owner, documentPath: data.data.documentPath }
//             : owner
//         )
//       );
//     } else {
//       toast.error(data?.data?.msg || "An error occurred.");
//     }
//     setUploadDocument(false);
//     setSelectedData("");
//   };

//   const onUploadDocumentError = (error) => {
//     toast.error(error?.response?.data?.msg || "An error occurred.");
//     setUploadDocument(false);
//   };
//   const { isLoading: uploadDocumentLoading, mutate: uploadDocumentMutate } =
//     useMutation(uploadDocumentFunction, {
//       onSuccess: onUploadDocumentSuccess,
//       onError: onUploadDocumentError,
//     });
//   const downloadQuery = `&propId=${property?.id}&fileType=${1}&reportType=${13}`;
//   const [reportUrl, setReportUrl] = useState();

//   useEffect(() => {
//     if (reportUrl) {
//       const link = document.createElement("a");
//       link.href = reportUrl;
//       link.setAttribute("download", "");
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       setReportUrl(null);
//     }
//   }, [reportUrl]);
//   const downloadFunction = async (values) => {
//     const response = await axios.get(
//       `${Config.apiUrl}/report/generate?${downloadQuery}`,
//       {
//         headers: {
//           authorization: "Bearer " + user.token,
//           "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         },
//       }
//     );
//     return response.data;
//   };
//   const onDownloadSuccess = (res) => {
//     if (res.isSuccess === false) {
//       toast.error(res.msg || "No data found for the selected date range");
//     } else if (res.reportUrl === false) {
//       toast.error("No data found for the selected date range");
//     } else {
//       setReportUrl(res.reportUrl);
//       toast.success(res.msg || "Report generated successfully");
//     }
//   };

//   const onDownloadError = (res) => {
//     toast.error(res.message || "Failed to download report");
//   };

//   const {
//     mutate: downloadReport,
//     isLoading: isDownloading,
//   } = useMutation(downloadFunction, {
//     onSuccess: onDownloadSuccess,
//     onError: onDownloadError,
//   });

//   return (
//     <BoxContainer>
//       <BoxHead>
//         <BoxTitle className="!mb-0 whitespace-nowrap">
//           Property Agreements
//           <Underline />
//         </BoxTitle>
//         <DownloadBtn type="button" onClick={() => downloadReport()}>
//           {isDownloading ? "Downloading..." : "Download"}
//         </DownloadBtn>
//       </BoxHead>

//       <SideModal
//         isOpen={showViewLeaseModel}
//         onClose={handleCloseLeaseViewModal}
//       >
//         <ViewLeaseDetails
//           leaseData={leaseData}
//           handleClose={handleCloseLeaseViewModal}
//           selectedData={selectedData}
//           setShowUploadForm={setShowUploadForm}
//           showUploadForm={showUploadForm}
//           addDocumentLoading={addDocumentLoading}
//           addDocumentMutate={addDocumentMutate}
//           documentData={documentData}
//           setShowEditLeaseModel={setShowEditLeaseModel}
//           setShowManagePaymentModel={setShowManagePaymentModel}
//           fromPage={"list"}
//         />
//       </SideModal>

//       <SideModal
//         isOpen={showManagePaymentModel}
//         onClose={handleManagePaymentModal}
//       >
//         <ManagePaymentDetails
//           leaseData={leaseData}
//           handleClose={handleManagePaymentModal}
//           selectedData={selectedData}
//           savePaymentLoading={savePaymentLoading}
//           savePaymentMutate={savePaymentMutate}
//           setShowManagePaymentModel={setShowManagePaymentModel}
//         />
//       </SideModal>

//       <SideModal
//         isOpen={showEditLeaseModel}
//         onClose={handleCloseLeaseEditModal}
//       >
//         <EditLandlordLeaseDetails
//           leaseData={leaseData?.leaseDetails}
//           handleClose={handleCloseLeaseEditModal}
//           editLandlordLoading={editLandlordLoading}
//           editLandlordMutate={editLandlordMutate}
//         />
//       </SideModal>

//       <FloorTabs>
//         <FloorTab
//           key="ALL"
//           onClick={() => setActiveTab('1')}
//           $active={activeTab === "1"}
//         >
//           Agreements
//         </FloorTab>
//         <FloorTab
//           key="ALL"
//           onClick={() => setActiveTab('2')}
//           $active={activeTab === "2"}
//         >
//           Lease Expiring
//         </FloorTab>
//         <FloorTab
//           key="ALL"
//           onClick={() => setActiveTab('3')}
//           $active={activeTab === "3"}
//         >
//           Lockin Completed
//         </FloorTab>
//       </FloorTabs>
//       {activeTab === "1" &&
//         <FilterTableWrapper>
//           <FilterWrapper>
//             <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
//               <SearchFilterBox
//                 options={searchOptions}
//                 handleFilterChange={handleFilterChange}
//                 handleClearFilters={handleClearFilters}
//               />
//             </div>
//           </FilterWrapper>
//           {!error && !isLoading && data && (
//             <TableWrapper>
//               <Table
//                 apiData={apiData || []}
//                 setSelectedData={setSelectedData}
//                 selectedData={selectedData}
//                 handleFetch={handleFetch}
//               />
//               {(!apiData || apiData.length === 0) && <NotFoundModel />}
//             </TableWrapper>
//           )}
//         </FilterTableWrapper>
//       }

//       {activeTab === "2" &&
//         <>
//           {(isLoading || isRefetching) && !isFocused && (
//             <SummarySkeletonLoading count={3} />
//           )}
//           {isFocused && apiData && (
//             <SummaryCardForExpiring summaryData={summaryData} onClick={onSummaryBoxClick} />
//           )}

//           {!error && !isLoading && apiData && (
//             <TableWrapper>
//               <TableForExpiring
//                 apiData={error ? [] : apiData?.length > 0 ? apiData : []}
//                 setSelectedData={setSelectedData}
//                 selectedData={selectedData}
//               //setEditUser={setEditUser}
//               //setViewDetail={setViewDetail}
//               //setUploadDocument={setUploadDocument}
//               //userType={user.userType}
//               //setOpenKYCModel={setOpenKYCModel}
//               //setIsRenewAgreement={setIsRenewAgreement}
//               />
//               {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"All good! No leases are expiring."} />}
//             </TableWrapper>
//           )}
//         </>
//       }

//       {activeTab === "3" &&
//         <>
//           {(isLoading || isRefetching) && !isFocused && (
//             <SummarySkeletonLoading count={3} />
//           )}
//           {isFocused && apiData && (
//             <SummaryCardForLockin summaryData={summaryData} onClick={onSummaryBoxClickForExpiring} />
//           )}

//           {!error && !isLoading && apiData && (
//             <TableWrapper>
//               <TableForLockin
//                 apiData={error ? [] : apiData?.length > 0 ? apiData : []}
//                 setSelectedData={setSelectedData}
//                 selectedData={selectedData}
//               />
//               {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"No Data Found."} />}
//             </TableWrapper>
//           )}
//         </>
//       }

//       {error && !isLoading && <NotFoundModel />}
//       {(isLoading || isRefetching) && <Loading />}
//     </BoxContainer>
//   );
// };

// const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
// const FloorTab = tw.button`
//   ${(p) =>
//     p.$active
//       ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
//       : " text-gray-700 "} 
//    px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
// `;
// const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
// const DownloadBtn = tw.button`${(p) =>
//   p.$active
//     ? "bg-gray-100"
//     : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color rounded-md px-6 cursor-pointer bg-white hover:bg-hover-color h-full py-2.5 text-sm`;
// export default AgreementsList;
